import { AuthContextType } from '../AuthContext';

let authContextValue: AuthContextType | null = null;

export const setAuthContext = (value: AuthContextType) => {
  authContextValue = value;
};

export const getAuthContext = () => authContextValue;
